import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { checkNested } from 'srcReact/helpers/validator'
import Icon from 'srcReact/components/icons/Icon'
import { formatDate, getDateFormat2 } from 'srcReact/helpers/datetimeHelper'
import { getConvertCentToDollar } from 'srcReact/helpers/utils'
import { organizationSettingsActions } from 'srcReact/OrganizationSettingsPage'
import Calendar from 'srcReact/components/common2/Calendar'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import DesktopHeader from '../DesktopHeader'
import Spinner from 'srcReact/components/common2/Spinner'

const Invoices = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    organization: { current_organization },
    organizationSettings: { invoices, loading },
    common: { currencies, isMobile }
  } = useSelector((state) => state)
  const [startDate, setStartDate] = useState({
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [endDate, setEndDate] = useState({
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(
        organizationSettingsActions.getInvoices(
          current_organization.info.id,
          startDate.value ? formatDate(startDate.value, appConstantSettings.DATE_FORMAT8) : '',
          endDate.value ? formatDate(endDate.value, appConstantSettings.DATE_FORMAT8) : ''
        )
      )
    }
  }, [
    current_organization && current_organization.info && current_organization.info.id,
    startDate.value,
    endDate.value
  ])

  const handleStartDate = (value) => {
    setStartDate({
      ...startDate,
      value: value,
      hasError: false,
      errorMessage: ''
    })
  }
  const handleEndDate = (value) => {
    setEndDate({
      ...endDate,
      value: value,
      hasError: false,
      errorMessage: ''
    })
  }
  const handleDownloadInvoice = (invoice) => {
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(organizationSettingsActions.downloadInvoice(current_organization.info.id, invoice.invoice_id))
    }
  }

  return (
    <div className={styles.invoicesWrapper}>
      {!isMobile && (
        <DesktopHeader
          title={t('organizationSettings.invoices.title')}
          subtitle={t('organizationSettings.invoices.subtitle')}
        />
      )}
      <div className={styles.startEndDate}>
        <Calendar
          defaultDate={new Date()}
          date={startDate.value}
          handleDateChange={handleStartDate}
          containerCSS={styles.calendar}
          showIcon={true}
          placeholder={t('global.startDate')}
        />
        <Calendar
          defaultDate={new Date()}
          date={endDate.value}
          minDate={startDate.value || new Date()}
          handleDateChange={handleEndDate}
          containerCSS={styles.calendar}
          showIcon={true}
          placeholder={t('global.endDate')}
        />
      </div>

      {loading ? (
        <Spinner customCss={styles.spinner} />
      ) : (
        <div className={styles.invoices}>
          {invoices.length >= 1 &&
            invoices.map((invoice, idx) => (
              <div key={idx} className={styles.invoiceCard}>
                <div className={styles.date}>{formatDate(invoice.date, getDateFormat2())}</div>
                <div className={styles.total}>{getConvertCentToDollar(invoice.total, invoice.currency_code)}</div>
                <button className={styles.download} onClick={() => handleDownloadInvoice(invoice)}>
                  {t('global.download')} <Icon name='arrow-down' size='medium' />
                </button>
              </div>
            ))}
        </div>
      )}
    </div>
  )
}

export default Invoices
